<template>
  <div @click="open">
    <slot />
  </div>
</template>

<script>
const unplashKey = 'OMoRexrKBLPZrbuYAMUZlffzTEmbauoRKogIPQyfeeQ'
import { Uppload, it, Local, Unsplash, Camera, Crop } from 'uppload'

export default {
  name: 'Uppload',
  props: {
    uploader: Function,
    width: Number,
    height: Number,
    defaultCrops: {
      type: Boolean,
      default: false,
    },
    disableCrop: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  created() {
    let extraPlugins = []
    let maxSize = []
    if (this.defaultCrops) {
      extraPlugins.push(
        new Crop({
          aspectRatio: 16 / 9,
        }),
      )
    } else {
      if (this.width !== 1 && this.height !== 1 && !this.disableCrop) {
        extraPlugins.push(
          new Crop({
            aspectRatio: this.width / this.height,
          }),
        )
        maxSize = [this.width, this.height]
      }
    }
    if (unplashKey !== '') {
      extraPlugins.push(new Unsplash(unplashKey))
    }

    if (!this.uppload) {
      this.uppload = new Uppload({
        lang: it,
        uploader: this.uploader,
        maxSize: maxSize,
        compressionFromMimes: ['image/jpeg', 'image/webp', 'image/png'],
      })
      this.uppload.use([new Local(), new Camera()])

      if (extraPlugins.length !== 0) {
        this.uppload.updatePlugins(plugins => {
          extraPlugins.map(extraPlug => plugins.push(extraPlug))
          return plugins
        })
      }

      this.uppload.on('upload', url => this.$emit('input', url))

      document.addEventListener('keyup', this.close)
    }
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.close)
  },
  methods: {
    open() {
      this.uppload.open()
    },
    close(evt) {
      //if keyup ESC
      if (evt.keyCode === 27) {
        this.uppload.close()
      }
    },
  },
}
</script>

<style>
@import '~uppload/dist/uppload.css';
@import '~uppload/dist/themes/light.css';

.uppload-container .uppload-modal .uppload-button {
  background-color: white !important;
  border: 1px solid #000 !important;
  border-color: #d2d2d2 !important;
  color: #000 !important;
  border-radius: 0px !important;
  padding: 1.25rem 1.875rem !important;
}

.uppload-container .uppload-modal .effects-nav {
  background-color: white !important;
  padding: 8px 0px !important;
}

.uppload-container .uppload-modal button.effects-continue--upload {
  background-color: #4a90e2 !important;
  border-radius: 0px !important;
}

.uppload-container .uppload-modal .need-help-link {
  display: none !important;
  border-radius: 0px !important;
}

.service-icon {
  margin: 2rem;
}

.service-icon svg {
  width: 4rem;
  height: 4rem;
  margin: 0 auto;
}
</style>
